module.exports = __webpack_public_path__ + "images/GSE_Logo_White_R.svg";